// Dynamically determine backend URL based on environment or current origin
export const getBackendUrl = () => {
  // First priority: environment variable
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // Fallback: use current origin (works for any deployment domain)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  return '';
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;
